import React, { useEffect } from 'react';
import { Mixpanel } from 'utils/Mixpanel';

function NoResults({ area, category, filters }) {
    useEffect(() => {
        Mixpanel.track('Search no results', {
            area: area?.name,
            interest: category?.name
        });
    }, [area?.name, category?.name]);
    return (
        <div className="no-results">
            <h2 className="text-center">Ni zadetkov</h2>
            {area && category && filters.length === 0 && (
                <p className="text-center mt-2">
                    Za območje <i>{area.name}</i> in kategorijo <i>{category.name}</i> ideje za izlete še nabiramo.
                </p>
            )}
        </div>
    );
}

NoResults.propTypes = {};

export default NoResults;
